import { useLoaderData } from "react-router-dom";
import { getRecipeByName } from "../../services/RecipeService";
import { CUSTOM } from "../../util/constants";
import { titleCase } from "../../util/util";
import { useEffect } from "react";
import Grid, { Item } from "../../components/grid/Grid";
import styles from './RecipeView.module.css'

const RecipeView = () => {
	const recipe = useLoaderData()
	const title = titleCase(recipe.name)

	const uom = (ing) => ing.unitOfMeasure === CUSTOM ? ing.customUnitOfMeasure : ing.unitOfMeasure

	useEffect(() => {
		document.title = title
	}, [title]);

	return (
		<div className={ styles.recipeView }>
			<h1>{ title }</h1>
			<Grid cols={ 2 } gap={ 0 }>
				<Item>
					<div>
						<h2>Instructions</h2>
						<div className={ styles.listWrapper }>
							{ recipe.instructions }
						</div>
					</div>
				</Item>
				<Item>
					<div>
						<h2>Ingredients</h2>
						<div className={ styles.listWrapper }>
							<ul>
								{
									recipe.ingredients.map((ingredient, index) => (
										<li key={ index }>{ ingredient }</li>
									))
								}
							</ul>
						</div>
					</div>
				</Item>
			</Grid>
		</div>
	)
}

const recipeLoader = ({ params }) => {
	return getRecipeByName(params.name)
}

export default RecipeView
export { recipeLoader }
